import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core";
import {formatDate, getDetail, getFileUrls, getStaticFileUrls, isHidden} from "../utils/Functions";
import Constants from "../utils/Constants";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";
import CloudOutlinedIcon from '@mui/icons-material/CloudOutlined';
import CloudOffOutlinedIcon from '@mui/icons-material/CloudOffOutlined';
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import BackspaceOutlinedIcon from "@mui/icons-material/BackspaceOutlined";
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import KeyboardDoubleArrowDownOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowDownOutlined';
import KeyboardDoubleArrowUpOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowUpOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';


const useStyles = makeStyles(theme => ({
    outer_div: {
        minHeight: '100vh',
    },
    card: {
        backgroundColor: '#424242',
        color: '#EEEEEE',
    },
    itemBar: {
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#222222',
    },
    pageBar: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        backgroundColor: '#222222',
        color: '#AAAAAA',
    },
    collapsableTableComponent: {
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px',
        borderBottom: '1px solid #ccc'
    },
    tableComponent: {
        borderStyle: 'solid',
        borderColor: '#000',
        borderRadius: '10px',
        borderSpacing: '0px',
        borderRightWidth: '0px',
        borderTopWidth: '1px',
        borderBottomWidth: '0px',
        borderLeftWidth: '0px',
        // backgroundColor: '#222222' // setting this breaks row highlighting
    },
    tableCell: {
        paddingLeft: '12px',
        paddingRight: '12px',
        borderBottom: '1px solid #444',
        color: '#CCCCCC',
    },
    clickableTableCell: {
        paddingLeft: '12px',
        borderBottom: '1px solid #444',
        cursor: 'pointer',
    },
    dialog: {
        backgroundColor: '#333333',
        color: '#CCCCCC',
        margin: '10',
    },
    dialogTitleBar: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogConfirm: {
        backgroundColor: '#149616',
        color: '#CCCCCC',
    },
    dialogNeutral: {
        backgroundColor: '#4e54bf',
        color: '#CCCCCC',
    },
    dialogWarning: {
        backgroundColor: '#d42842',
        color: '#CCCCCC',
    },
    primaryColor: {
        color: '#000',
        backgroundColor: '#111'
    },
    whiteColor: {
        color: "#EEE",
    },
    hide: {
        display: 'none',
    },
    spaced: {
        margin: '10px',
    }
}))


export default function Analyzer({ analyzer, headers, siteData, policyData, prefetchSelectedRow, handleOpenEdit, handleOpenDelete, handleOpenDeploy, winInstallerUrl }) {
    const classes = useStyles()
    const [isOpen, setIsOpen] = useState(true);
    const [isCollapsable, setIsCollapsable] = useState(analyzer.hasOwnProperty('children') && analyzer['children'].length > 0);
    const last_seen_threshold = 900

    function isOnline(last_seen) {
        const epochSeconds = Math.floor(Date.now() / 1000);
        return epochSeconds - last_seen < last_seen_threshold
    }

    const toggleOpen = () => {
        setIsOpen(!isOpen);
    };

    function getNameByPk(table, pk) {
        switch (table) {
            case 'site':
                let site = siteData.find(i => i.pk === pk)
                if (site) {
                    return site['site_name']
                }
                break
            case 'policy':
                let policy = policyData.find(i => i.pk === pk)
                if (policy) {
                    return policy['policy_name']
                }
                break
            default:
                return null
        }
    }

    function getDeployButton(pk, deployed, type) {
        const color = 'primary'
        if (type === 'SMB' ) {
            return (
                <td className={isHidden('deploy', headers) ? classes.hide : classes.clickableTableCell}>
                    <RocketLaunchOutlinedIcon color={color} onClick={() => window.open(winInstallerUrl, '_blank')} disabled={winInstallerUrl === '' ? true : false} />
                </td>
            )
        }
        else if (type === 'S3') {
            return (
                <td className={isHidden('deploy', headers) ? classes.hide : classes.clickableTableCell}>
                    <RocketLaunchOutlinedIcon color={color} onClick={(e) => handleOpenDeploy(e, pk, type)} />
                </td>
            )
        }
        else if (type === 'GDrive') {
            return (
                <td className={isHidden('deploy', headers) ? classes.hide : classes.clickableTableCell}>
                    <RocketLaunchOutlinedIcon color={color} onClick={(e) => handleOpenDeploy(e, pk, type)} />
                </td>
            )
        }
        else {
            return (
                <td className={isHidden('deploy', headers) ? classes.hide : classes.clickableTableCell}>
                    <RocketLaunchOutlinedIcon color={color} disabled={true} />
                </td>
            )
        }
    }

    function getExpandButton(an_analyzer) {
        if (an_analyzer['install_type'] === 'Distributed' &&
            (an_analyzer['analyzer_name'] === 'not assigned' || an_analyzer['analyzer_name'] === '') &&
            an_analyzer['node_type'] !== 'Analyzer') {
            return (
                    <td className={isHidden('collapse', headers) ? classes.hide : classes.clickableTableCell}>
                        <ReportProblemOutlinedIcon color={"error"} onClick={(e) => toggleOpen()} />
                    </td>
                )
        }
        if (an_analyzer['analyzer_name'] && an_analyzer['analyzer_name'] === analyzer['pk']) {
            return (
                <td className={isHidden('collapse', headers) ? classes.hide : classes.clickableTableCell}></td>
            )
        }
        if (isCollapsable) {
            if (isOpen) {
                return (
                    <td className={isHidden('collapse', headers) ? classes.hide : classes.clickableTableCell}>
                        <KeyboardDoubleArrowDownOutlinedIcon color={"primary"} onClick={(e) => toggleOpen()} />
                    </td>
                )
            }
            else {
                return (
                    <td className={isHidden('collapse', headers) ? classes.hide : classes.clickableTableCell}>
                        <KeyboardArrowRightOutlinedIcon color={"primary"} onClick={(e) => toggleOpen()} />
                    </td>
                )
            }
        }
        else {
            return (
                <td className={isHidden('collapse', headers) ? classes.hide : classes.clickableTableCell}>
                    <KeyboardArrowRightOutlinedIcon color={"disabled"} />
                </td>
            )
        }
    }

    function getRow(an_analyzer) {
        if (isCollapsable) {
            return (
            <tr
                key={an_analyzer.pk} onClick={() => prefetchSelectedRow(an_analyzer.pk)}
                className={classes.tableComponent}
            >
                {getExpandButton(an_analyzer)}
                <td className={isHidden('seen', headers) ? classes.hide : classes.clickableTableCell}>
                    {isOnline(an_analyzer.seen) ? <CloudOutlinedIcon color={"success"}/> :
                        <CloudOffOutlinedIcon color={"error"}/>}
                </td>
                <td className={isHidden('pk', headers) ? classes.hide : classes.tableCell}>{an_analyzer.pk}</td>
                <td className={isHidden('site_uuid', headers) ? classes.hide : classes.tableCell}>{getNameByPk('site', an_analyzer.site_uuid)}</td>
                <td className={isHidden('storage_type', headers) ? classes.hide : classes.tableCell}>{an_analyzer.storage_type}</td>
                <td className={isHidden('cloud_region', headers) ? classes.hide : classes.tableCell}>{an_analyzer.cloud_region}</td>
                <td className={isHidden('policy_uuid', headers) ? classes.hide : classes.tableCell}>{getNameByPk('policy', an_analyzer.policy_uuid)}</td>
                <td className={isHidden('log_level', headers) ? classes.hide : classes.tableCell}>{an_analyzer.log_level}</td>
                <td className={isHidden('created', headers) ? classes.hide : classes.tableCell}>{formatDate(an_analyzer.created)}</td>
                <td className={isHidden('modified', headers) ? classes.hide : classes.tableCell}>{formatDate(an_analyzer.modified)}</td>
                <td className={isHidden('edit', headers) ? classes.hide : classes.clickableTableCell}>
                    <EditOutlinedIcon color={"primary"} onClick={(e) => handleOpenEdit(e, an_analyzer.pk)}/>
                </td>
                {getDeployButton(an_analyzer.pk, an_analyzer.policies_deployed, an_analyzer.storage_type)}
                <td className={isHidden('delete', headers) ? classes.hide : classes.clickableTableCell}>
                    <BackspaceOutlinedIcon color={"error"}
                                           onClick={(e) => handleOpenDelete(e, an_analyzer.pk)}/>
                </td>
            </tr>
            )
        }
        else {
            return (
                <tr
                    //onClick={handleOpenEdit(analyzer.hk, analyzer.pk)}
                    key={an_analyzer.pk} onClick={() => prefetchSelectedRow(an_analyzer.pk)}
                    className={classes.tableComponent}
                >
                    {getExpandButton(an_analyzer)}
                    <td className={isHidden('seen', headers) ? classes.hide : classes.clickableTableCell}>
                        {isOnline(an_analyzer.seen) ? <CloudOutlinedIcon color={"success"}/> :
                            <CloudOffOutlinedIcon color={"error"}/>}
                    </td>
                    <td className={isHidden('pk', headers) ? classes.hide : classes.tableCell}>{an_analyzer.pk}</td>
                    <td className={isHidden('site_uuid', headers) ? classes.hide : classes.tableCell}>{getNameByPk('site', an_analyzer.site_uuid)}</td>
                    <td className={isHidden('storage_type', headers) ? classes.hide : classes.tableCell}>{an_analyzer.storage_type}</td>
                    <td className={isHidden('cloud_region', headers) ? classes.hide : classes.tableCell}>{an_analyzer.cloud_region}</td>
                    <td className={isHidden('policy_uuid', headers) ? classes.hide : classes.tableCell}>{getNameByPk('policy', an_analyzer.policy_uuid)}</td>
                    <td className={isHidden('log_level', headers) ? classes.hide : classes.tableCell}>{an_analyzer.log_level}</td>
                    <td className={isHidden('created', headers) ? classes.hide : classes.tableCell}>{formatDate(an_analyzer.created)}</td>
                    <td className={isHidden('modified', headers) ? classes.hide : classes.tableCell}>{formatDate(an_analyzer.modified)}</td>
                    <td className={isHidden('edit', headers) ? classes.hide : classes.clickableTableCell}>
                        <EditOutlinedIcon color={"primary"} onClick={(e) => handleOpenEdit(e, an_analyzer.pk)}/>
                    </td>
                    {getDeployButton(an_analyzer.pk, an_analyzer.policies_deployed, an_analyzer.storage_type)}
                    <td className={isHidden('delete', headers) ? classes.hide : classes.clickableTableCell}>
                        <BackspaceOutlinedIcon color={"error"}
                                               onClick={(e) => handleOpenDelete(e, an_analyzer.pk)}/>
                    </td>
                </tr>
            )
        }
    }

    return (
        <>
            {getRow(analyzer, true)}
            {isOpen && analyzer['children'] && analyzer['children'].map(child => (
                getRow(child, false)
                )
            )
            }
        </>
    )
}

